import { FormFieldType, IFormGroupConfig } from '@shared/ui';

export const filterFormConfig: IFormGroupConfig = {
  type: FormFieldType.GROUP,
  fields: {
    name: {
      type: FormFieldType.INPUT,
      label: 'Название оператора:',
      placeholder: 'Введите название',
    },
    code: {
      type: FormFieldType.INPUT,
      label: 'Код:',
      placeholder: 'Введите код',
    },
  },
};
